import { ForecastOption } from "../../../../../../../../../services/cloudchipr.api";

export const forecastedCostOptionLabels: Map<ForecastOption, string> = new Map([
  ["month", "Month-end"],
  ["quarter", "Quarter-end"],
]);
